'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _pulse = require('../loaders/pulse');

var _pulse2 = _interopRequireDefault(_pulse);

var _engage = require('../loaders/engage');

var _engage2 = _interopRequireDefault(_engage);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trackerId = _ref.trackerId,
        trackerId = _ref$trackerId === undefined ? 'pulse-view-article' : _ref$trackerId;

    return {
        track: function track(params) {
            var _this = this;

            return new _promise2.default(function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                    var sdk, _params$utm, campaign, channel, content, source, terms, event, origin;

                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (params) {
                                        _context.next = 2;
                                        break;
                                    }

                                    return _context.abrupt('return', reject(new Error('Tracking params must be specified')));

                                case 2:
                                    _context.next = 4;
                                    return (0, _pulse2.default)({ providerId: params.site, trackerId: trackerId });

                                case 4:
                                    sdk = _context.sent;
                                    _params$utm = params.utm;
                                    _params$utm = _params$utm === undefined ? {} : _params$utm;
                                    campaign = _params$utm.campaign, channel = _params$utm.channel, content = _params$utm.content, source = _params$utm.source, terms = _params$utm.terms;
                                    event = {
                                        object: {
                                            category: params.content.categories[0],
                                            custom: {
                                                'spt:site': params.site.toUpperCase(),
                                                'spt:url': params.url,
                                                'spt:articleId': params.content.id,
                                                'spt:group': params.content.group,
                                                'spt:device': params.device,
                                                'spt:permalink': params.url,
                                                'spt:shareUrl': {
                                                    facebook: params.url,
                                                    twitter: params.url
                                                },
                                                'spt:previewUrl': {
                                                    http: params.url,
                                                    https: params.url
                                                },
                                                'spt:published': params.content.published,
                                                'spt:updated': params.content.updated,
                                                'spt:authors': params.content.authors,
                                                'spt:wordCount': params.content.wordcount,
                                                'spt:imageUrl': (0, _util.getImageUrl)(),
                                                paywallType: params.content.paywallType
                                            },
                                            contentId: params.content.id,
                                            id: params.content.id,
                                            type: params.type || 'Article',
                                            accessLevel: params.content.accessLevel
                                        },
                                        actor: {
                                            id: params.userId,
                                            realm: params.userRealm
                                        },
                                        provider: {
                                            id: params.site,
                                            product: params.site,
                                            productTag: params.content.productTag,
                                            'spt:engage': params.site.toUpperCase()
                                        },
                                        origin: {
                                            campaign: campaign,
                                            channel: channel,
                                            content: content,
                                            source: source,
                                            terms: terms
                                        }
                                    };


                                    window.pulse(trackerId + '.update', event);

                                    _context.next = 12;
                                    return sdk.evaluateEvent('trackerEvent', event).then(function (compiledEvent) {
                                        var compiledOrigin = (0, _assign2.default)({}, compiledEvent.object);
                                        delete compiledOrigin['spt:custom'];
                                        return compiledOrigin;
                                    });

                                case 12:
                                    origin = _context.sent;
                                    _context.next = 15;
                                    return (0, _engage2.default)({
                                        trackerId: trackerId,
                                        pingOptions: { event: { origin: origin } },
                                        overlayOptions: { enabled: params.enableOverlay },
                                        historyOptions: { objectType: params.type || 'Article' }
                                    });

                                case 15:

                                    window.pulse(trackerId + '.track', 'trackerEvent');

                                    return _context.abrupt('return', resolve({
                                        response: 'Pulse+Engage view tracking completed.',
                                        params: params,
                                        trackerId: trackerId
                                    }));

                                case 17:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
    };
}; /* global window */
//# sourceMappingURL=article.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/trackers/pulse/view/article.js
 ** module id = 306
 ** module chunks = 0
 **/